import { all } from 'redux-saga/effects'
import checkAuth from './checkAuth'

export default function* rootSaga() {
    yield all([
        checkAuth(),
    ])
}
